module.exports = __webpack_public_path__ + "static/media/IconExamSetCompetitionAddMargin.df14ce69.svg";